import React, { useRef } from 'react'
import {Box, Typography, Paper, useMediaQuery} from '@mui/material';
import { motion } from 'framer-motion';

function About() {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  return (
    <Box component={"div"} id='about' py={5}>
        <Typography variant='h3' sx={{fontWeight: "700"}} textAlign="center" width={300} borderBottom="1px solid" borderColor={"primary"} m="auto" color="primary">About Me</Typography>
        <motion.div
          initial={{
            x: "-100%",
            opacity: 0,
          }}
          whileInView={{
            x: 0,
            opacity: 1,
          }}
          transition={{
            delay: 0,
            type: "spring",
            ease: "linear",
            duration: 2
          }}
        >
          <Box mx={isSmallScreen ? 2 : 20} mt={5}>
              <Paper elevation={3} sx={{padding: "20px"}}>
                  <Typography textAlign="justify" sx={{textAlign: 'justify', fontWeight: '500'}}>
                      Hello, I'm Sidul Islam Moon, a passionate MERN stack web developer with a love for creating clean, elegant, and responsive web applications. With a strong foundation in modern web technologies, I'm dedicated to delivering seamless user experiences.
                      My journey into the world of web development started in 2019. Since then, I've honed my skills in the MERN (MongoDB, Express, React, Node.js) stack, building dynamic and interactive web solutions.
                  </Typography>
              </Paper>
          </Box>
        </motion.div>
    </Box>
  )
}

export default About